"use client"

import { useInView } from "react-intersection-observer"
import { useState } from "react"
import "../assets/css/what-we-do.css"
// Make sure you import the 'Image' component from Next.js for better performance
import SandunImg from "../assets/images/sandun.jpg"
import PrabathImg from "../assets/images/prabath.png"
import ThilinaImg from "../assets/images/thilina.jpg"
import AsiriImg from "../assets/images/asiri.jpg"

export default function WhatWeDo() {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  })

  const [flippedCards, setFlippedCards] = useState<Record<number, boolean>>({})

  const toggleCard = (index: number) => {
    setFlippedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  const services = [
    {
      icon: (
        <svg
          className="what-we-do-service-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M2 12H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Fresh Produce",
      description: "We grow a variety of fruits, vegetables, and herbs, ensuring freshness and flavor.",
    },
    {
      icon: (
        <svg
          className="what-we-do-service-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 10V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16V14M21 10L15 14M21 10L15 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Value-Added Products",
      description:
        "We process and package our crops into convenient and nutritious products such as dried fruits, jams, and sauces.",
    },
    {
      icon: (
        <svg
          className="what-we-do-service-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 6.25278V19.2528M12 6.25278C10.8321 5.47686 9.24649 5 7.5 5C5.75351 5 4.16789 5.47686 3 6.25278V19.2528C4.16789 18.4769 5.75351 18 7.5 18C9.24649 18 10.8321 18.4769 12 19.2528M12 6.25278C13.1679 5.47686 14.7535 5 16.5 5C18.2465 5 19.8321 5.47686 21 6.25278V19.2528C19.8321 18.4769 18.2465 18 16.5 18C14.7535 18 13.1679 18.4769 12 19.2528"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Agricultural Consulting",
      description:
        "We provide expert advice and guidance on sustainable farming techniques, crop selection, and pest management.",
    },
    {
      icon: (
        <svg
          className="what-we-do-service-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9 9H9.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M15 9H15.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: "Sustainable Farming",
      description:
        "We are committed to environmentally friendly farming methods that minimize our impact on the planet.",
    },
    {
      icon: (
        <svg
          className="what-we-do-service-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.5 12.5719L12 19.9999L4.5 12.5719C2.5 10.5719 2.5 7.07192 4.5 5.07192C6.5 3.07192 10 3.07192 12 5.07192C14 3.07192 17.5 3.07192 19.5 5.07192C21.5 7.07192 21.5 10.5719 19.5 12.5719Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Community Engagement",
      description:
        "We actively engage with local communities, supporting their livelihoods and promoting sustainable development.",
    },
  ]

  const teamMembers = [
    {
      name: "Sandun Cooray",
      position: "Director & Secretary",
      image: SandunImg,
      bio: "Sandun is a Chartered Accountant (CA Sri Lanka & CAANZ) with over 13 years of experience in auditing and finance across industries such as agriculture, manufacturing, and services. Having worked in Sri Lanka, Jamaica, the Maldives, and Australia, he brings valuable international insight to the business. At Green Beat Ceylon, he combines his professional expertise with a personal passion for sustainable agriculture, helping guide the company's growth, governance, and commitment to delivering high-quality produce",
    },
    {
      name: "Prabath Chandrasekara",
      position: "Director",
      image: PrabathImg,
      bio: "Prabath is a Chartered Public Accountant (CPA Australia) and a Chartered Accountant (ACA Sri Lanka) with professional experience in both Australia and Sri Lanka. He has a strong background in auditing, financial strategy, and business advisory, working with companies across diverse sectors, including agriculture. Currently serving as the Director of Marketing and Operations at Green Beat Ceylon Pvt Ltd, Prabath combines his international financial expertise with hands-on agricultural knowledge to lead sustainable agribusiness ventures. His dual qualifications and cross-border experience position him to deliver strategic, innovative, and future-focused growth for Green Beat and its partners."
    },
    {
      name: "Thilina Prasad",
      position: "Manager - Operations",
      image: ThilinaImg,
    },
    {
      name: "Asiri Priyankara",
      position: "Agricultural officer",
      image: AsiriImg,
    },
  ]

  return (
    <section ref={ref} className="what-we-do-section">
      <div className="what-we-do-container">
        {/* Services Section */}
        <div className="what-we-do-header">
          <h2 className={`what-we-do-title ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.2s" }}>
            What We Do
          </h2>
          <div className={`what-we-do-divider ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.3s" }}></div>
          <p className={`what-we-do-subtitle ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.4s" }}>
            We specialize in cultivating a diverse range of high-quality, nutritious crops using sustainable
            agricultural practices.
          </p>
        </div>

        <div className="what-we-do-services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`what-we-do-service-card ${inView ? "visible" : ""}`}
              style={{
                transitionDelay: `${500 + index * 100}ms`,
              }}
            >
              <div className="what-we-do-service-icon">{service.icon}</div>
              <h3 className="what-we-do-service-title">{service.title}</h3>
              <p className="what-we-do-service-description">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Team Section */}
        <div className="what-we-do-team-section">
          <div className="what-we-do-header">
            <h2 className={`what-we-do-title ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.8s" }}>
              Our Team
            </h2>
            <div className={`what-we-do-divider ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.9s" }}></div>
            <p className={`what-we-do-subtitle ${inView ? "visible" : ""}`} style={{ transitionDelay: "1s" }}>
              Meet our dedicated directors and team who make our sustainable farming vision a reality
            </p>
          </div>

          <div className="what-we-do-team-grid">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className={`what-we-do-team-member ${inView ? "visible" : ""}`}
                style={{
                  transitionDelay: `${1100 + index * 150}ms`,
                }}
              >
                <div className="what-we-do-member-image-container">
                  <div className={`what-we-do-member-card ${flippedCards[index] ? 'flipped' : ''}`}>
                    {/* Front of card - Image and Name */}
                    <div className="what-we-do-member-card-front">
                      <img
                        src={member.image || "/placeholder.svg"}
                        alt={member.name}
                        className="what-we-do-member-image"
                      />
                      
                      <div className="what-we-do-member-overlay">
                        <div className="what-we-do-member-details">
                          <h3 className="what-we-do-member-name">{member.name}</h3>
                          <p className="what-we-do-member-position">{member.position}</p>
                        </div>
                      </div>

                      {/* Flip button (only show if bio exists) */}
                      {member.bio && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleCard(index);
                          }}
                          className="what-we-do-flip-button"
                          aria-label="Read bio"
                        >
                          <svg viewBox="0 0 24 24" fill="none">
                            <path 
                              d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                              stroke="currentColor" 
                              strokeWidth="2" 
                              strokeLinecap="round" 
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    {/* Back of card - Bio (only if bio exists) */}
                    {member.bio && (
                      <div className="what-we-do-member-card-back">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleCard(index);
                          }}
                          className="what-we-do-flip-button-back"
                          aria-label="Show photo"
                        >
                          <svg viewBox="0 0 24 24" fill="none">
                            <path 
                              d="M6 18L18 6M6 6L18 18" 
                              stroke="currentColor" 
                              strokeWidth="2" 
                              strokeLinecap="round" 
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>

                        <div className="what-we-do-member-bio-back">
                          <h4 className="what-we-do-member-bio-title-back">About {member.name.split(" ")[0]}</h4>
                          <p className="what-we-do-member-bio-text">{member.bio}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="what-we-do-bg-circle what-we-do-bg-circle-1"></div>
      <div className="what-we-do-bg-circle what-we-do-bg-circle-2"></div>
    </section>
  )
}


